import { BASE_URL } from "application/constants/app-constants";
import getInitialUrl from "./getInitialUrl";

export default function getFullLinks(rawLinks) {
  return Object.keys(rawLinks).reduce((acc, k) => {
    acc[k] = `${getInitialUrl()}${BASE_URL}${rawLinks[k]}`;
    return acc;
  }, {});
}
